import React from "react";
import SvgIconDPC from "../dpc-svg-icon";

export default class DpcNavbar extends React.Component {

    /*chunk = (arr, size) => arr.reduce((acc, e, i) => (i % size ? acc[acc.length - 1].push(e) : acc.push([e]), acc), []);

    getChildren(children) {
        let newArray = children.sort((a, b) => a.weight > b.weight ? 1 : -1);
        return this.chunk(newArray, Math.min(2, newArray.length))
    }*/

    getHomepagePath = () => {
        let item = this.props.menuItems.find(item => item.title.toLowerCase() === 'homepage');
        if (item) {
            return item.link;
        }
        return '/';
    }

    render() {
        return (
            <div className="it-header-navbar-wrapper">
                <div className="container">
                    <div className="px-custom">
                        <nav className="navbar navbar-expand-xl has-megamenu" aria-label="Menu principale">
                            <button className="custom-navbar-toggler" type="button" aria-controls="navMain"
                                    aria-expanded="false" aria-label="Toggle navigation" data-target="#navMain"
                                    title="Navigazione menu principale">
                                <SvgIconDPC name={'burger'}/>
                            </button>
                            <div className="navbar-collapsable" id="navMain">
                                <div className="overlay"/>
                                <div className="menu-wrapper">
                                    <div className="close-div">
                                        <button className="btn close-menu" type="button" title="Chiudi menu">
                                            <SvgIconDPC name={'close'}/>
                                        </button>
                                    </div>
                                    <ul className="navbar-nav">
                                        <li className="nav-item nav-homepage">
                                            <a className="nav-link" href={this.getHomepagePath()}
                                               title="Homepage"><span>Homepage</span></a>
                                        </li>
                                        { 
                                            this.props.menuItems.filter(item => item.title.toLowerCase() !== 'homepage').sort((a, b) => {
                                                return a.weight > b.weight ? 1 : -1;
                                            }).map((item, i) => {
                                                return (
                                                    <>
                                                    {item.children?.length > 0 ?
                                                    <li className={`nav-item dropdown megamenu ${item.active ? "active" : ""}`}>
                                                        <a className={`nav-link dropdown-toggle ${item.active ? "active" : ""}`}
                                                           href={item.link ? item.link : `#`}
                                                           data-toggle="dropdown"
                                                           aria-expanded="false">
                                                            <span>{item.title}</span>
                                                            <SvgIconDPC name={'expand'} classiAggiuntive={"icon-sm"}/>
                                                        </a>
                                                        {item.children.length > 0 && (
                                                                <div className="dropdown-menu">
                                                                    <div className="link-list-wrapper">
                                                                        <ul className="link-list row">
                                                                            {
                                                                                item.children.sort((a, b) => {
                                                                                    return a.weight > b.weight ? 1 : -1;
                                                                                }).map(child => {
                                                                                        return (
                                                                                            <li className={`col-12 col-lg-3 ${child.active ? "active" : ""}`}>
                                                                                                <a className="list-item"
                                                                                                   href={child.link}><span>{child.title}</span></a>
                                                                                            </li>
                                                                                        )
                                                                                    }
                                                                                )
                                                                            }
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            )
                                                        }
                                                    </li>
                                                    :
                                                    <li className={`nav-item`}>
                                                        <a className={`nav-link`}
                                                        href={item.link ? item.link : `#`}
                                                        aria-expanded="false">
                                                            <span>{item.title}</span>                                                      
                                                        </a>
                                                    </li>
                                                    }
                                                    </>
                                                )
                                            })
                                        }
                                    </ul>
                                    <h4 className="social-title">{this.props.lang === 'it' ? 'Seguici su' : 'Follow us'}</h4>
                                    <ul className="list-inline text-left social">
                                        <li className="list-inline-item">
                                            <a href="https://www.facebook.com/iononrischio/"
                                               title="Pagina Facebook del Dipartimento della Protezione Civile"
                                               target="_blank"  rel="noreferrer">
                                                <SvgIconDPC name={'facebook'}/>
                                                <span className="sr-only">Facebook</span>
                                            </a>
                                        </li>
                                        <li className="list-inline-item">
                                            <a href="https://www.instagram.com/io_non_rischio/"
                                               title="Pagina Instagram del Dipartimento della Protezione Civile"
                                               target="_blank"  rel="noreferrer">
                                                <SvgIconDPC name={'instagram'}/>
                                                <span className="sr-only">Instagram</span>
                                            </a>
                                        </li>
                                        <li className="list-inline-item">
                                            <a href="https://twitter.com/iononrischio/"
                                               title="Segui il Dipartimento della Protezione Civile su Twitter"
                                               target="_blank"  rel="noreferrer">
                                                <SvgIconDPC name={'twitter'}/>
                                                <span className="sr-only">Twitter</span>
                                            </a>
                                        </li>
                                        <li className="list-inline-item">
                                            <a href="https://www.youtube.com/channel/UCdOg4quMoJDjQIkopcXkqCQ"
                                               title="Canale YouTube del Dipartimento della Protezione Civile"
                                               target="_blank" rel="noreferrer">
                                                <SvgIconDPC name={'youtube'}/>
                                                <span className="sr-only">YouTube</span>
                                            </a>
                                        </li>
                                        <li className="list-inline-item">
                                            <a href="https://www.flickr.com/photos/196243517@N02/albums"
                                               title="Profilo del Dipartimento della Protezione Civile su Flickr"
                                               target="_blank" rel="noreferrer">
                                                <SvgIconDPC name={'flickr'}/>
                                                <span className="sr-only">Flickr</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </nav>
                    </div>
                </div>
            </div>
        );
    }

}
